import React, { FC, useState } from "react";
import Input from "shared/Input/Input";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useAuth } from "./AuthContext";
import FailModal from 'containers/BlogPage/BlogModal/FailModal';
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";

export interface PageLoginProps {
  className?: string;
}

const AuthLogin: FC<PageLoginProps> = ({ className = "" }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const success = await login(email, password);
      if (success) {
        const from = (location.state as any)?.from?.pathname || "/";
        navigate(from, { replace: true });
      } else {
        setModalMessage("이메일 또는 비밀번호를 확인해 주세요.");
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error("Login error:", error);
      setModalMessage("오류가 발생했어요. 다시 시도해 주세요.");
      setIsModalOpen(true);
    }
  };

  return (
      <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
        <div className="container mb-24 lg:mb-32">
          <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
            로그인
          </h2>
          <div className="max-w-md mx-auto space-y-6">
            {/* FORM */}
            <form className="grid grid-cols-1 gap-6" onSubmit={handleSubmit}>
              <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">
                이메일
              </span>
                <Input
                    type="email"
                    placeholder="example@example.com"
                    className="mt-1"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)} // 이메일 입력 처리
                />
              </label>
              <label className="block">
              <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                비밀번호
              </span>
                <div className="relative mt-1">
                  <Input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-neutral-400 hover:text-neutral-600"
                  >
                    {showPassword ? <EyeSlashIcon className="w-5 h-5" /> : <EyeIcon className="w-5 h-5" />}
                  </button>
                </div>
              </label>
              <ButtonPrimary type="submit">로그인</ButtonPrimary>
            </form>

            {/* ==== */}
            <span className="block text-center text-neutral-700 dark:text-neutral-300">
            처음이신가요? {` `}
            <Link to="/signup" className="text-blue-600 font-semibold hover:underline">
                회원가입
            </Link>
          </span>
          </div>
        </div>
        <FailModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            title="로그인 실패"
            mainMessage={modalMessage}
            subMessage="다시 한번 시도해 보세요."
        />
      </div>
  );
};

export default AuthLogin;
